import apiCall from "@/data/axios";
import config from "../../../config/config";

import IApiV2Response from "@/data/interfaces/apiV2Response";
import { IFindAndCountResponse, IQuery } from "@/data/interfaces/apiV2Query";
import { ILocation, ILocationFilter } from "@/data/interfaces/location";

export default async function locationsGetV2(query: IQuery<ILocationFilter>): Promise<IFindAndCountResponse<ILocation>> {
	let locationsResponse: IFindAndCountResponse<ILocation> = {
		count: 0,
		rows: []
	};
	try {
		const response = await apiCall<IApiV2Response<IFindAndCountResponse<ILocation>>>("POST", "/api/v2/locations", query, config.api.replace("/v1", ""));

		if (response?.data?.data) locationsResponse = response.data.data;
	} catch(err: any) {
		console.error("Error fetching locations", err);
	}

	return locationsResponse;
}